const theme = {
  colors: {
    primary: '#fafafa',
  },
};

export default theme;
